module.exports = __webpack_public_path__ + "media/images/payments/discover-ac27d16a62e5320b55341d39d53820de.svg";